import { createContext, useContext } from "react";

export const AlertsEnabledContext = createContext<boolean>(true);

export const useAlertsEnabled = () => useContext(AlertsEnabledContext);
